/** "98765 43210" → "+919876543210"; "+1 415…" kept as typed (international). */
export function toE164(input: string, defaultCountry = '+91'): string | null {
  const trimmed = input.trim();
  const digits = trimmed.replace(/\D/g, '');
  const e164 = trimmed.startsWith('+')
    ? `+${digits}`
    : `${defaultCountry}${digits.replace(/^0+/, '')}`;
  if (!/^\+[1-9]\d{7,14}$/.test(e164)) return null;
  if (e164.startsWith('+91') && e164.length !== 13) return null;
  return e164;
}

/** "+919876543210" → "+91 ••••• •3210" for display. */
export function maskPhone(e164: string): string {
  return e164.length > 7 ? `${e164.slice(0, 3)} ••••• •${e164.slice(-4)}` : e164;
}

/** Last 4 digits for the "previously used" login hint. Only this fragment is
 *  ever persisted — never the full number — so returning users recognise
 *  which number they signed in with. Too-short input → null (no hint). */
export function last4(e164: string): string | null {
  const digits = e164.replace(/\D/g, '');
  return digits.length >= 4 ? digits.slice(-4) : null;
}
